<template>
  <main-nav-btn
    icon="fa-arrow-right-from-bracket"
    @click="logout"
    :tooltip="$t('common.logOut')"
    size="small"
    :shortcuts="['G', 'E']"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from "vue-router";
import { useAuthState } from "@frontegg/vue";
import { agentSettingsStore } from "src/stores/agent-settings-global-store";
import MainNavBtn from "components/MainNavBtn.vue";
import { useGraphqlSdk } from "src/graphql/graphql-client";

const agentSettingsStoreState = agentSettingsStore.getState();
const router = useRouter();
const authState = useAuthState();

const agentId = computed(() => agentSettingsStoreState.id)

const logout = async () => {
  await setAway();
  await router.push({
    path: authState.routes.logoutUrl,
  });
};

const setAway = async () => {
  try {
    const sdk = useGraphqlSdk();
    await sdk.SetAgentAwayStatus({
      input: {
        input: {
          agentId: agentId.value,
          away: true,
          awayFromPhone: true
        }
      }
    });
  }
  catch (err) {
    console.error(err);
  }
}
</script>

<style lang="sass"/>
